export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-100">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmospheric%20composition%20with%20warm%20golden%20and%20deep%20crimson%20lighting%2C%20abstract%20film%20reel%20and%20dramatic%20spotlight%20elements%2C%20Japanese%20and%20Korean%20cinema%20aesthetic%2C%20soft%20bokeh%20background%2C%20elegant%20theatrical%20mood%2C%20textured%20dark%20backdrop%20with%20subtle%20grain%2C%20editorial%20cinematography&width=1600&height=900&seq=hero-bg-drama&orientation=landscape"
          alt="日韩影视网主视觉背景"
          className="w-full h-full object-cover object-top opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-primary-500/15 text-primary-700 mb-5 whitespace-nowrap">
              每日同步更新 · 高清不缓冲
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-white leading-tight">
              日韩影视网
              <br />
              <span className="text-accent-400">日剧韩剧高清在线追剧平台</span>
            </h1>

            <p className="mt-1 text-lg md:text-xl text-white/80 font-heading">
              日剧全集 · 韩剧全集 · 不缓冲畅享观影
            </p>

            <p className="mt-5 text-sm md:text-base text-white/70 leading-relaxed max-w-xl lg:max-w-none">
              日韩影视网为您汇集日剧全集、韩剧全集等海量高清资源，覆盖爱情、悬疑、喜剧、古装等全品类剧集。每日同步更新最新日韩电视剧，无论是跟播热剧还是经典重温，都能在这里找到。我们采用高速CDN节点分发，确保高清不缓冲观影体验，让追剧永远不等待。
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-5 justify-center lg:justify-start">
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <span className="w-2 h-2 rounded-full bg-accent-400"></span>
                <span>每日更新 30+ 剧集</span>
              </div>
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <span className="w-2 h-2 rounded-full bg-accent-400"></span>
                <span>覆盖日韩全品类</span>
              </div>
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <span className="w-2 h-2 rounded-full bg-accent-400"></span>
                <span>1080P 高清不缓冲</span>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-8 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-white font-medium text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热播榜单
              </a>
              <a
                href="#media"
                className="inline-flex items-center gap-2 px-8 py-3 rounded-lg border border-white/30 hover:border-white/60 text-white font-medium text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                浏览精彩预告
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative">
              <div className="aspect-[3/4] rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20composition%20with%20elegant%20silhouettes%20in%20warm%20golden%20and%20crimson%20tones%2C%20Japanese%20and%20Korean%20television%20drama%20aesthetic%2C%20soft%20dramatic%20lighting%20with%20film%20grain%20texture%2C%20atmospheric%20mood%2C%20abstract%20storytelling%20elements%2C%20premium%20entertainment%20visual%20style&width=900&height=1200&seq=hero-poster-drama&orientation=portrait"
                  alt="日韩影视网精选剧集主视觉"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 bg-background-50 rounded-lg px-4 py-3 border border-background-200/60">
                <div className="flex items-center gap-2">
                  <span className="w-3 h-3 rounded-full bg-accent-400 animate-pulse"></span>
                  <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">正在热播中</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}